import { render, staticRenderFns } from "./QEditor.vue?vue&type=template&id=212d2e10&scoped=true"
import script from "./QEditor.vue?vue&type=script&lang=js"
export * from "./QEditor.vue?vue&type=script&lang=js"
import style0 from "./QEditor.vue?vue&type=style&index=0&id=212d2e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d2e10",
  null
  
)

export default component.exports